import React, { useEffect, useState } from "react";
import './Headernav.scss';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserGroup } from "@fortawesome/free-solid-svg-icons/faUserGroup";
import { faBook, faChartBar, faFileExcel, faHouse, faIdCard, faPowerOff, faPrint, faUserPlus, faUserTie } from "@fortawesome/free-solid-svg-icons";
import { NavLink, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import Label_print from "../label_printing/label";
import axios from "axios";
import { API_BASE } from "../apiBase";



let Headernav=()=>{
    
    let navigate=useNavigate();
    const [permissions, setPermissions] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('permissions') || '[]');
        } catch (error) {
            return [];
        }
    });
    const userRole = localStorage.getItem('user_role');
    const canAddMember = userRole === "super_admin";
    const canManageAdmins = userRole === "super_admin";
    const canAnnualMalar = userRole === "super_admin" || permissions.includes("annual_malar");
    const canLabel = userRole === "super_admin";
    const canAuditHistory = userRole === "super_admin";
    const canExportMembers = userRole === "super_admin";
    const annualMalarLabel = "\u0B86\u0BA3\u0BCD\u0B9F\u0BC1 \u0BAE\u0BB2\u0BB0\u0BCD";
    const annualMalarHistoryLabel = "\u0BAE\u0BB2\u0BB0\u0BCD \u0BB5\u0BB0\u0BB2\u0BBE\u0BB1\u0BC1";
    
    let logout=()=>{
        const username = localStorage.getItem('user_name');
        const role = localStorage.getItem('user_role');
        if (username) {
            const fd = new FormData();
            fd.append('username', username);
            fd.append('role', role || '');
            axios.post(`${API_BASE}/log_logout.php`, fd).catch(() => {});
        }
        localStorage.removeItem('token'); 
        localStorage.removeItem('user');
        localStorage.removeItem('user_role');
        localStorage.removeItem('user_name');
        localStorage.removeItem('permissions');
        navigate('/login');
    }   
    let adminpage=()=>{
        
        navigate('/admin-details');
        
    }
    let homepage=()=>{
        navigate('/');
     
    }
    let addmember=()=>{
        navigate('/addmember');
    }

    useEffect(() => {
        const username = localStorage.getItem('user_name');
        if (!username) {
            return;
        }
        axios.get(`${API_BASE}/permissions_get.php?username=${encodeURIComponent(username)}`)
            .then((response) => {
                const perms = Array.isArray(response.data) ? response.data : [];
                setPermissions(perms);
                localStorage.setItem('permissions', JSON.stringify(perms));
            })
            .catch(() => {});
    }, []);
   
    return(
        <>
            <div className="nav-box" >
            

            
                <div className="menu-options">
                <div onClick={homepage} className="menus"  >
                        
                        <FontAwesomeIcon className="menus_icon" icon={faHouse}  />
                        <p className="menu_para">HOME</p>
                      
                    </div>
             
                    {canAddMember && (
                        <div onClick={addmember} className="menus"  >
                            
                            <FontAwesomeIcon className="menus_icon" icon={faUserPlus}  />
                            <p className="menu_para">MEMBER</p>
                          
                        </div>
                    )}
                  
                    {canLabel && (
                        <div className="menus" onClick={()=>{navigate('/print-the-member-label-for-post')}}>
                            <FontAwesomeIcon className="menus_icon" icon={faPrint} />
                            <p className="menu_para">LABEL</p>
                        </div>
                    )}
                    {canAnnualMalar && (
                        <>
                        <div className="menus" onClick={()=>{navigate('/annual-malar')}}>
                            <FontAwesomeIcon className="menus_icon" icon={faBook} />
                            <p className="menu_para">{annualMalarLabel}</p>
                        </div>
                        <div className="menus" onClick={()=>{navigate('/annual-malar-history')}}>
                            <FontAwesomeIcon className="menus_icon" icon={faChartBar} />
                            <p className="menu_para">{annualMalarHistoryLabel}</p>
                        </div>
                        </>
                    )}

                    {canManageAdmins ? (
                        <Tooltip   arrow title="ADMIN ?r??r??r??r??rT?_??r?r3?_^ ?r??r_?r??_??r?r??r ?rr?r??_??r??_??rr?_? ?rs?_??r??_??r?r??r?_^?r?r??r?_? ?r??r?_^ ?r.?r'?_??r?_??r?r??_??rr?_? ">
                        <div className="menus" onClick={adminpage}   >
                            <FontAwesomeIcon className="menus_icon" icon={faUserTie} />
                            <p className="menu_para">ADMINS</p>
                        </div>
                        </Tooltip>
                    ) : ""}

                    {canAuditHistory && (
                        <div className="menus" onClick={()=>{navigate('/addmember#audit-history')}}>
                            <FontAwesomeIcon className="menus_icon" icon={faUserGroup} />
                            <p className="menu_para">HISTORY</p>
                        </div>
                    )}

                    {canExportMembers && (
                        <div className="menus" onClick={()=>{navigate('/export-members')}}>
                            <FontAwesomeIcon className="menus_icon" icon={faFileExcel} />
                            <p className="menu_para">EXPORT</p>
                        </div>
                    )}
                    
                    <Tooltip arrow  title="வேலை முடிந்தபின் இதை அழுத்தி வெளியில் செல்லவும் ">
                    <div className="menus" onClick={logout}>
                      
                        <FontAwesomeIcon style={{color:"red"}}  className="menus_icon" icon={faPowerOff} />
                        <p className="menu_para">LOGOUT</p>
                        
                    </div>
                    </Tooltip>
                  
                    
                  
                  <div className="user_details">
                  <Tooltip arrow  title={localStorage.getItem('user')}>
                    <div className="menus" onClick={()=>navigate('/my-profile')}>
                      
                        <FontAwesomeIcon style={{color:"red"}}  className="menus_icon" icon={faIdCard} />
                        <p className="menu_para">MY PROFILE</p>
                        
                    </div>
                    </Tooltip>
                    
                  </div>
                  <div>
      
    </div>


                </div>
            </div>
        </>
    );
}

export default Headernav;
